<template>
	<div class="vertical-menu">
		<div class="navbar-brand-box">
			<router-link :to="{path: '/'}" class="logo logo-dark">
				<span class="logo-sm">
					<img src="/assets/images/logo-sm-colored.svg" alt="Krasp" />
				</span>
				<span class="logo-lg">
					<img src="/assets/images/logo-lg-colored.svg" alt="Krasp" />
				</span>
			</router-link>
			<router-link :to="{path: '/'}" class="logo logo-light">
				<span class="logo-sm">
					<img src="/assets/images/logo-sm-white.svg" alt="Krasp" />
				</span>
				<span class="logo-lg">
					<img src="/assets/images/logo-lg-white.svg" alt="Krasp" />
				</span>
			</router-link>
		</div>
		<button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn" @click="toggleVerticalMenu()">
			<i class="fa fa-fw fa-bars"></i>
		</button>
		<div data-simplebar class="sidebar-menu-scroll">
			<div id="sidebar-menu">
				<ul class="metismenu list-unstyled" id="side-menu">
					<li :class="{'menu-title': item.type == 'title'}" v-for="item in appModel.navbarMenu">
						<span v-if="item.type == 'title'">{{item.text}}</span>
						<router-link v-if="item.type == 'item'" custom :to="{path: item.path}" v-slot="{href, route, navigate, isActive, isExactActive}">
							<a :href="item.path != '#' ? href : '#'" @click="navigate" :class="{'active': item.path != '#' ? isExactActive : false, 'disabled': item.disabled, 'has-arrow waves-effect': typeof(item.childs) !== 'undefined' && item.childs.length > 0}">
								<i v-if="item.icon" :class="item.icon"></i>
								<span v-if="item.badgeText != ''" :class="['badge', 'float-end', item.badgeClass, {'rounded-pill bg-primary': item.badgeClass != ''}]">{{item.badgeText}}</span>
								<span>{{item.text}}</span>
							</a>
						</router-link>
						<ul class="sub-menu" aria-expanded="true" v-if="item.type == 'item' && typeof(item.childs) !== 'undefined' && item.childs.length > 0">
							<li v-for="sitem in item.childs">
								<router-link custom :to="{path: sitem.path}" v-slot="{href, route, navigate, isActive, isExactActive}">
									<a :href="sitem.path != '#' ? href : '#'" @click="navigate" :class="{'active': sitem.path != '#' ? isExactActive : false, 'disabled': sitem.disabled, 'has-arrow': sitem.childs.length > 0}">
										<span v-if="sitem.badgeText != ''" :class="['badge', 'float-end', sitem.badgeClass, {'rounded-pill bg-primary': sitem.badgeClass != ''}]">{{sitem.badgeText}}</span>
										<span>{{sitem.text}}</span>
									</a>
								</router-link>
								<ul class="sub-menu" aria-expanded="true" v-if="typeof(sitem.childs) !== 'undefined' && sitem.childs.length > 0">
									<li v-for="s2item in sitem.childs">
										<router-link custom :to="{path: s2item.path}" v-slot="{href, route, navigate, isActive, isExactActive}">
											<a :href="href" @click="navigate" :class="{'active': isExactActive, 'disabled': s2item.disabled}">{{s2item.text}}</a>
										</router-link>
									</li>
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';

export default {
	name: 'VerticalMenu',
	mixins: lib.mixins,
	props: {},
	data: () => ({
		
	}),
	methods: {
		toggleVerticalMenu(){
			document.body.classList.toggle('sidebar-enable');
			
			if(992 <= window.innerWidth){
				let a = document.body.getAttribute('data-sidebar-size');
				if(null == a){
					if(null == document.body.getAttribute('data-sidebar-size')
					|| 'lg' == document.body.getAttribute('data-sidebar-size')){
						document.body.setAttribute('data-sidebar-size', 'sm');
					} else {
						document.body.setAttribute('data-sidebar-size', 'lg');
					}
				} else {
					if('md' == a){
						if('md' == document.body.getAttribute('data-sidebar-size')){
							document.body.setAttribute('data-sidebar-size', 'sm');
						} else {
							document.body.setAttribute('data-sidebar-size', 'md');
						}
					} else {
						if('sm' == document.body.getAttribute('data-sidebar-size')){
							document.body.setAttribute('data-sidebar-size', 'lg');
						} else {
							document.body.setAttribute('data-sidebar-size', 'sm');
						}
					}
				}
			}
		},
	},
	beforeMount(){},
	computed: {},
}
</script>